export default __webpack_public_path__ + "static/media/Audit.e1b4dbda.png";